module.exports = __webpack_public_path__ + "img/the_compoud_effect.ee83dbff.png";